import { ApiPaymentStatus } from "src/api/types";
import Badge from "src/components/Badge";
import usePaymentStatus from "src/hooks/data/usePaymentStatus";

interface PaymentBadgeProps {
	status: ApiPaymentStatus;
}

const color = {
	completed: {
		bg: "green",
		color: "white",
	},
	reserved: {
		bg: "green",
		color: "white",
	},
	cancelled: {
		bg: "red",
		color: "white",
	},
	chargeback: {
		bg: "red",
		color: "white",
	},
	expired: {
		bg: "red",
		color: "white",
	},
	failed: {
		bg: "red",
		color: "white",
	},
	credit: {
		bg: "red",
		color: "white",
	},
} as any;

const PaymentBadge = ({ status }: PaymentBadgeProps) => {
	const label = usePaymentStatus(status);
	return (
		<Badge
			bg={color[status]?.bg || "gray"}
			color={color[status]?.color || "dark"}
		>
			{label}
		</Badge>
	);
};

export default PaymentBadge;
